import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = loading, null = anon

    const check = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (_e) {
            setUser(null);
        }
    }, []);

    useEffect(() => {
        if (localStorage.getItem("ebg_token")) {
            check();
        } else {
            setUser(null);
        }
    }, [check]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.access_token) localStorage.setItem("ebg_token", data.access_token);
            setUser(data.user);
            return { ok: true, user: data.user };
        } catch (e) {
            return { ok: false, error: formatApiError(e) };
        }
    };

    const register = async (payload) => {
        try {
            const { data } = await api.post("/auth/register", payload);
            if (data.access_token) localStorage.setItem("ebg_token", data.access_token);
            setUser(data.user);
            return { ok: true, user: data.user };
        } catch (e) {
            return { ok: false, error: formatApiError(e) };
        }
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (_e) { /* noop */ }
        localStorage.removeItem("ebg_token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, register, logout, refresh: check }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
